<template>
    <el-form ref="form" :model="innerFormData" :label-width="innerLabelWidth" :rules="rules">
        <el-form-item v-for="item in items" :key="item.name" :label="item.label" :prop="item.name" v-show="!item.hidden">
            <component
                :is="item.type"
                v-model="innerFormData[item.name]"
                v-bind="item.extendProps || {}"
                @input="changeHandler"
                @change="changeHandler"
                @validate="validateField(item.name)"
            />
        </el-form-item>
        <el-form-item align="right">
            <slot name="footer">
                <el-button round @click="cancel">{{ $t("zhiji.common.cancel") }}</el-button>
                <el-button round type="primary" @click="confirm">{{ $t("zhiji.common.confirm") }}</el-button>
            </slot>
        </el-form-item>
    </el-form>
</template>

<script>
import ImageCover from "./items/ImageCover";
import RadioGroup from "./items/RadioGroup";
import ArrayInput from "./items/ArrayInput";
import ArraySelect from "./items/ArraySelect";
import LinkWordText from "./items/LinkWordText";
import QuestionSelect from "./items/QuestionSelect";
import Select from "./items/Select";
import CheckGroup from "./items/CheckGroup";

/**
 *  formData:{name1:val1, name2:val2}
 *  setting:[{name: "name1", label: "label1", type:"el-input"}]
 * */
export default {
    name: "Form",
    props: ["formData", "items", "labelWidth", "rules"],
    components: {
        ImageCover,
        RadioGroup,
        ArrayInput,
        LinkWordText,
        QuestionSelect,
        Select,
        CheckGroup,
        ArraySelect,
    },
    data() {
        const innerFormData = {};
        const formData = this.formData || {};
        this.items.forEach(item => {
            innerFormData[item.name] = formData.hasOwnProperty(item.name) ? formData[item.name] : "";
        });

        return {
            innerFormData
        };
    },
    computed: {
        innerLabelWidth() {
            return this.labelWidth || "100px";
        }
    },
    watch: {
        formData: {
            handler(newData) {
                this.innerFormData = newData;
            },
            immediate: true,
        }
    },
    methods: {
        confirm() {
            this.$emit("submit", this.innerFormData);
        },
        cancel() {
            this.$emit("close");
        },
        changeHandler() {
            this.$emit("change", this.innerFormData);
        },
        validate(callback) {
            this.$refs.form.validate(callback);
        },
        validateField(field) {
            this.$refs.form.validateField(field);
        }
    }
};
</script>

<style></style>
